export type CellAgent = {
  corpusId: number;
  displayValue: string;
  metadata?: {
    evidenceId?: null | number;
  };
  editedValue?: string | number | null;
  editedByUUID?: string | null;
};

export type CellAgentResponseFromApi = {
  corpus_id: number;
  display_value: string;
  metadata?: {
    evidence_id?: null | number;
  };
  editedValue?: string | number | null;
  editedByUUID?: string | null;
};

export function getTableCellFromApi(cell: CellAgentResponseFromApi): CellAgent {
  return {
    corpusId: cell.corpus_id,
    displayValue: cell.display_value,
    metadata: {
      evidenceId: cell.metadata?.evidence_id ?? null,
    },
    editedValue: cell.editedValue,
    editedByUUID: cell.editedByUUID,
  };
}

export type TablePaperRecommendationResponse = {
  papers: {
    corpus_id: number;
    title: string;
  }[];
};
